import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'

/** Область редактирования CKEditor (контент, режим source) */
function getMainEditableElements (root) {
  return root.querySelectorAll(
    '.ck-editor__editable:not(.ck-editor__nested-editable), ' +
    '.ck-source-editing-area textarea'
  )
}

/**
 * Ресайз основной области CKEditor.
 * @param {import('vue').Ref} rootRef
 */
export function useCkeditorResize (rootRef, { defaultHeight = 300, minHeight = 120 } = {}) {
  const height = ref(defaultHeight)
  let observer = null
  let refreshTimer = null

  const applyMainHeight = () => {
    const root = rootRef.value
    if (!root) return

    getMainEditableElements(root).forEach((el) => {
      el.style.setProperty('height', `${height.value}px`, 'important')
      el.style.setProperty('min-height', `${height.value}px`, 'important')
      el.style.setProperty('max-height', `${height.value}px`, 'important')
      el.style.overflowY = 'auto'
      el.style.resize = 'none'
    })
  }

  const scheduleRefresh = () => {
    clearTimeout(refreshTimer)
    refreshTimer = setTimeout(applyMainHeight, 80)
  }

  const startResize = (e) => {
    e.preventDefault()
    e.stopPropagation()

    const startY = e.clientY
    const startH = height.value

    const onMove = (ev) => {
      height.value = Math.max(minHeight, startH + ev.clientY - startY)
      applyMainHeight()
    }

    const onUp = () => {
      document.removeEventListener('mousemove', onMove)
      document.removeEventListener('mouseup', onUp)
      document.body.style.cursor = ''
      document.body.style.userSelect = ''
    }

    document.body.style.cursor = 'ns-resize'
    document.body.style.userSelect = 'none'
    document.addEventListener('mousemove', onMove)
    document.addEventListener('mouseup', onUp)
  }

  onMounted(() => {
    nextTick(() => {
      const tryInit = () => {
        const root = rootRef.value
        if (!root?.querySelector('.ck-editor')) {
          setTimeout(tryInit, 150)
          return
        }
        applyMainHeight()
        observer = new MutationObserver(() => scheduleRefresh())
        observer.observe(root, { childList: true, subtree: true })
      }
      tryInit()
    })
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
    clearTimeout(refreshTimer)
  })

  return { height, startResize, applyMainHeight }
}
